import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ManagecommunicationComponent } from './managecommunication.component';

const routes: Routes = [
    {
        path: '',
        component: ManagecommunicationComponent,
        data: {
            title: 'Manage Communication'
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ManageCommunicationRoutingModule { }
